import React from "react"

import FTPServer from "../../../../components/Products/Outdoor_Cameras/IN-7011/Videos/video-7011-overview"

import SEOHelmet from '../../../../components/Layout/SEOHelmet'
import Footer from '../../../../components/Layout/footer/'

const seodata = {
  title: 'INSTAR IN-7011 HD',
  description: 'The IN-7011 HD is a weather proof dome camera which can be used inside and outside. A motor allows for change of the lenses viewing direction.',
  image: '/images/Search/P_SearchThumb_IN-7011HD.png'
}

export default (props) => (
  <React.Fragment>
    <SEOHelmet title={seodata.title} description={seodata.description} image={seodata.image} location={props.location.pathname} />
    <h1 id="introduction" style={{ marginTop: 0 }}>
      IN-7011 720p HD Pan&Tilt-IP-Kamera für den Außeneinsatz + iPad App
    </h1>
    <FTPServer />
    <br />
    <br />
    <Footer
      previousTitle="Usermanual"
      previousLink="/fr/Outdoor_Cameras/IN-7011_HD/Usermanual/"
      nextTitle="SD Card"
      nextLink="/fr/Outdoor_Cameras/IN-7011_HD/Video/SD_Card/" />
  </React.Fragment>
)